import React from 'react';
import { ArrowUpRight } from 'lucide-react';
const portfolioItems = [{
  category: 'Corporate',
  title: 'Tech Startup Merch',
  color: 'bg-blue-100'
}, {
  category: 'Events',
  title: 'Marathon 2024',
  color: 'bg-red-100'
}, {
  category: 'Retail',
  title: 'Streetwear Collection',
  color: 'bg-stone-200'
}, {
  category: 'Uniforms',
  title: 'Restaurant Staff',
  color: 'bg-indigo-100'
}, {
  category: 'Non-Profit',
  title: 'Volunteer Gear',
  color: 'bg-green-100'
}, {
  category: 'Sports',
  title: 'League Jerseys',
  color: 'bg-orange-100'
}];
export function Portfolio() {
  return <section id="portfolio" className="py-24 bg-white" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-141">
          <div className="max-w-2xl" data-id="element-142">
            <h2 className="text-red-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-143">
              Recent Work
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold text-blue-900" data-id="element-144">
              Quality You Can See
            </h3>
          </div>
          <a href="#" className="hidden md:flex items-center text-blue-900 font-semibold hover:text-red-600 transition-colors mt-4 md:mt-0" data-id="element-145">
            View Full Portfolio <ArrowUpRight className="ml-2 h-4 w-4" data-id="element-146" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-147">
          {portfolioItems.map((item, index) => <div key={index} className="group relative overflow-hidden rounded-lg aspect-[4/3] cursor-pointer" data-id="element-148">
              {/* Placeholder Background */}
              <div className={`absolute inset-0 ${item.color} transition-transform duration-500 group-hover:scale-105`} data-id="element-149">
                {/* Abstract Pattern for placeholder */}
                <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-black to-transparent" data-id="element-150"></div>
                <div className="absolute bottom-0 right-0 p-8 opacity-20" data-id="element-151">
                  <svg width="100" height="100" viewBox="0 0 100 100" fill="currentColor" className="text-blue-900" data-id="element-152">
                    <path d="M50 0 L100 100 L0 100 Z" data-id="element-153" />
                  </svg>
                </div>
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-blue-900/0 group-hover:bg-blue-900/80 transition-colors duration-300 flex items-center justify-center" data-id="element-154">
                <div className="text-center opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 p-4" data-id="element-155">
                  <p className="text-red-400 font-medium text-sm uppercase tracking-wider mb-2" data-id="element-156">
                    {item.category}
                  </p>
                  <h4 className="text-white text-xl font-bold" data-id="element-157">{item.title}</h4>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-8 text-center md:hidden" data-id="element-158">
          <a href="#" className="inline-flex items-center text-blue-900 font-semibold hover:text-red-600 transition-colors" data-id="element-159">
            View Full Portfolio <ArrowUpRight className="ml-2 h-4 w-4" data-id="element-160" />
          </a>
        </div>
      </div>
    </section>;
}